'use es6';

import { createSelector } from 'reselect';
import I18n from 'I18n';
export const getAdProfile = state => state.adProfile;
export const getDaysSinceFirstAccountConnect = createSelector(getAdProfile, ({
  firstConnectedAt
}) => I18n.moment().diff(I18n.moment(firstConnectedAt), 'days'));
export const getHasCreatedLeadAd = createSelector(getAdProfile, ({
  hasCreatedLeadAd
}) => hasCreatedLeadAd);
export const getAdSpendCurrencyChoice = createSelector(getAdProfile, ({
  adSpendCurrencyChoice
}) => adSpendCurrencyChoice);